import React from 'react';

export default function QueueIcon({ active = false, size = 22, ...props }) {
  const stroke = active ? 'rgba(255,215,0,0.9)' : 'rgba(255,215,0,0.6)';
  const fillAccent = active ? 'rgba(255,215,0,0.15)' : 'rgba(255,215,0,0.08)';

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {/* Jukebox body */}
      <path d="M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z" stroke={stroke} strokeWidth="1.6" />
      {/* Arched top window */}
      <path d="M7 6h10a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1z" stroke={stroke} strokeWidth="1.2" fill={fillAccent} />
      {/* Record disc */}
      <circle cx="12" cy="16.5" r="2.5" stroke={stroke} strokeWidth="1.4" />
      <circle cx="12" cy="16.5" r="0.8" fill={stroke} stroke="none" />
      {/* Selection buttons */}
      <line x1="8" y1="9" x2="11" y2="9" stroke={stroke} strokeWidth="1" strokeLinecap="round" />
      <line x1="13" y1="9" x2="16" y2="9" stroke={stroke} strokeWidth="1" strokeLinecap="round" />
    </svg>
  );
}
